/**
 * @flow
 * @relayHash 6bb2267409beac5e7d89ad0619d7263f
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type PolicyEditor_document$ref = any;
type PolicyEditor_editorPropertiesOverride$ref = any;
export type OverridePolicyQueryVariables = {|
  documentPk: number
|};
export type OverridePolicyQueryResponse = {|
  +documentOverride: ?{|
    +document: ?{|
      +$fragmentRefs: PolicyEditor_document$ref
    |},
    +canLocalize: ?boolean,
    +editForm: ?{|
      +name: ?string,
      +author: ?{|
        +pk: ?number,
        +firstName: string,
        +lastName: string,
        +title: ?string,
      |},
      +category: ?{|
        +pk: ?number,
        +name: string,
      |},
      +categoryChoices: ?$ReadOnlyArray<?{|
        +pk: ?number,
        +name: string,
      |}>,
      +flowTemplate: ?{|
        +pk: ?number,
        +name: ?string,
      |},
      +flowTemplateChoices: ?$ReadOnlyArray<?{|
        +pk: ?number,
        +name: ?string,
      |}>,
      +bloc: ?{|
        +pk: ?number,
        +name: string,
      |},
      +blocChoices: ?$ReadOnlyArray<?{|
        +pk: ?number,
        +name: string,
      |}>,
      +html: ?string,
      +activeLifespan: ?number,
      +expirationDate: ?string,
      +isAForm: ?boolean,
      +restricted: ?boolean,
      +legacyEffectiveDate: ?string,
      +approvalDate: ?string,
      +regulations: ?$ReadOnlyArray<?number>,
      +onesourceDocuments: ?$ReadOnlyArray<?{|
        +oneSourceDocumentId: string,
        +catalogNumber: ?string,
        +manufacturerName: ?string,
        +viewUrl: ?string,
        +revisionInformation: string,
      |}>,
    |},
    +tagForm: ?{|
      +tags: ?$ReadOnlyArray<?{|
        +pk: ?number,
        +name: string,
      |}>
    |},
    +scheduledEffectiveDateForm: ?{|
      +effectiveDate: ?string,
      +effectiveDateTimedelta: ?number,
      +effectiveDateAlgorithm: ?string,
      +originationDate: ?string,
    |},
    +preimportRevisionForm: ?{|
      +revisionDates: ?$ReadOnlyArray<?string>
    |},
    +systemDocumentTemplateForm: ?{|
      +blocs: ?$ReadOnlyArray<?{|
        +pk: ?number,
        +name: string,
      |}>
    |},
    +error: ?{|
      +statusCode: ?number,
      +message: ?string,
    |},
    +tenantsToRedirect: ?$ReadOnlyArray<?{|
      +name: string,
      +url: ?string,
    |}>,
    +redirectUrl: ?string,
    +policyActions: ?any,
    +$fragmentRefs: PolicyEditor_editorPropertiesOverride$ref,
  |}
|};
export type OverridePolicyQuery = {|
  variables: OverridePolicyQueryVariables,
  response: OverridePolicyQueryResponse,
|};
*/


/*
query OverridePolicyQuery(
  $documentPk: Int!
) {
  documentOverride(pk: $documentPk) {
    document {
      ...PolicyEditor_document
      id
    }
    canLocalize
    editForm {
      name
      author {
        pk
        firstName
        lastName
        title
        id
      }
      category {
        pk
        name
        id
      }
      categoryChoices {
        pk
        name
        id
      }
      flowTemplate {
        pk
        name
        id
      }
      flowTemplateChoices {
        pk
        name
        id
      }
      bloc {
        pk
        name
        id
      }
      blocChoices {
        pk
        name
        id
      }
      html
      activeLifespan
      expirationDate
      isAForm
      restricted
      legacyEffectiveDate
      approvalDate
      regulations
      onesourceDocuments {
        oneSourceDocumentId
        catalogNumber
        manufacturerName
        viewUrl
        revisionInformation
        id
      }
    }
    tagForm {
      tags {
        pk
        name
        id
      }
    }
    scheduledEffectiveDateForm {
      effectiveDate
      effectiveDateTimedelta
      effectiveDateAlgorithm
      originationDate
    }
    preimportRevisionForm {
      revisionDates
    }
    systemDocumentTemplateForm {
      blocs {
        pk
        name
        id
      }
    }
    error {
      statusCode
      message
    }
    tenantsToRedirect {
      name
      url
      id
    }
    ...PolicyEditor_editorPropertiesOverride
    redirectUrl
    policyActions
  }
}

fragment PolicyEditor_document on DocumentType {
  id
  pk
  name
  status
  actions(isEditPage: false) {
    id
    pk
    actionType
    actionDate
    comment
    canEdit
    isExternal
    user {
      id
      userDisplay(userDisplayType: FORWARD)
    }
  }
  epAssociationDocuments {
    pk
    id
  }
  systemDocumentTemplate {
    pk
    id
  }
  ...commentForm_document
  isTemplate
}

fragment PolicyEditor_editorPropertiesOverride on DocumentOverrideType {
  ckeditor5
  ...editor_editorPropertiesOverride
}

fragment editor_editorPropertiesOverride on DocumentOverrideType {
  rtlSupport
  newCkeditor
  ckeditor5
  ckeditor5AiEnabled
  ckeditor5LicenseKey
}

fragment commentForm_document on DocumentType {
  id
  pk
  canComment
  status
  subscribedToComments
  usersNotificationComment {
    usersNotificationCommentOn {
      pk
      firstName
      lastName
      id
    }
    usersNotificationCommentOff {
      pk
      firstName
      lastName
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "documentPk",
    "type": "Int!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "pk",
    "variableName": "documentPk",
    "type": "Int!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "canLocalize",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "pk",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "firstName",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "lastName",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v8 = [
  v4,
  v3
],
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "html",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "activeLifespan",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "expirationDate",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isAForm",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "restricted",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "legacyEffectiveDate",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "approvalDate",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "regulations",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "oneSourceDocumentId",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "catalogNumber",
  "args": null,
  "storageKey": null
},
v19 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "manufacturerName",
  "args": null,
  "storageKey": null
},
v20 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "viewUrl",
  "args": null,
  "storageKey": null
},
v21 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "revisionInformation",
  "args": null,
  "storageKey": null
},
v22 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "scheduledEffectiveDateForm",
  "storageKey": null,
  "args": null,
  "concreteType": "OverrideScheduledEffectiveDateForm",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "effectiveDate",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "effectiveDateTimedelta",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "effectiveDateAlgorithm",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "originationDate",
      "args": null,
      "storageKey": null
    }
  ]
},
v23 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "preimportRevisionForm",
  "storageKey": null,
  "args": null,
  "concreteType": "PreimportRevisionDatesFormType",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "revisionDates",
      "args": null,
      "storageKey": null
    }
  ]
},
v24 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "error",
  "storageKey": null,
  "args": null,
  "concreteType": "ErrorType",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "statusCode",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "message",
      "args": null,
      "storageKey": null
    }
  ]
},
v25 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "url",
  "args": null,
  "storageKey": null
},
v26 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "redirectUrl",
  "args": null,
  "storageKey": null
},
v27 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "policyActions",
  "args": null,
  "storageKey": null
},
v28 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v29 = [
  v4,
  v28
],
v30 = [
  v4,
  v5,
  v6,
  v28
],
v31 = [
  v4,
  v3,
  v28
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "OverridePolicyQuery",
  "id": "b9fee06d60efb79bef7bac9d178f4713",
  "text": null,
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "OverridePolicyQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "documentOverride",
        "storageKey": null,
        "args": v1,
        "concreteType": "DocumentOverrideType",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "document",
            "storageKey": null,
            "args": null,
            "concreteType": "DocumentType",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "PolicyEditor_document",
                "args": null
              }
            ]
          },
          v2,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "editForm",
            "storageKey": null,
            "args": null,
            "concreteType": "DocumentOverrideFormType",
            "plural": false,
            "selections": [
              v3,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "author",
                "storageKey": null,
                "args": null,
                "concreteType": "UserType",
                "plural": false,
                "selections": [
                  v4,
                  v5,
                  v6,
                  v7
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "category",
                "storageKey": null,
                "args": null,
                "concreteType": "CategoryType",
                "plural": false,
                "selections": v8
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "categoryChoices",
                "storageKey": null,
                "args": null,
                "concreteType": "CategoryType",
                "plural": true,
                "selections": v8
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "flowTemplate",
                "storageKey": null,
                "args": null,
                "concreteType": "ApprovalWorkflowType",
                "plural": false,
                "selections": v8
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "flowTemplateChoices",
                "storageKey": null,
                "args": null,
                "concreteType": "ApprovalWorkflowType",
                "plural": true,
                "selections": v8
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "bloc",
                "storageKey": null,
                "args": null,
                "concreteType": "BlocType",
                "plural": false,
                "selections": v8
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "blocChoices",
                "storageKey": null,
                "args": null,
                "concreteType": "BlocType",
                "plural": true,
                "selections": v8
              },
              v9,
              v10,
              v11,
              v12,
              v13,
              v14,
              v15,
              v16,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "onesourceDocuments",
                "storageKey": null,
                "args": null,
                "concreteType": "OneSourceDocumentType",
                "plural": true,
                "selections": [
                  v17,
                  v18,
                  v19,
                  v20,
                  v21
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "tagForm",
            "storageKey": null,
            "args": null,
            "concreteType": "TagFormType",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "tags",
                "storageKey": null,
                "args": null,
                "concreteType": "TagType",
                "plural": true,
                "selections": v8
              }
            ]
          },
          v22,
          v23,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "systemDocumentTemplateForm",
            "storageKey": null,
            "args": null,
            "concreteType": "SystemDocumentTemplateFormType",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "blocs",
                "storageKey": null,
                "args": null,
                "concreteType": "BlocType",
                "plural": true,
                "selections": v8
              }
            ]
          },
          v24,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "tenantsToRedirect",
            "storageKey": null,
            "args": null,
            "concreteType": "TenantType",
            "plural": true,
            "selections": [
              v3,
              v25
            ]
          },
          {
            "kind": "FragmentSpread",
            "name": "PolicyEditor_editorPropertiesOverride",
            "args": null
          },
          v26,
          v27
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "OverridePolicyQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "documentOverride",
        "storageKey": null,
        "args": v1,
        "concreteType": "DocumentOverrideType",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "document",
            "storageKey": null,
            "args": null,
            "concreteType": "DocumentType",
            "plural": false,
            "selections": [
              v28,
              v4,
              v3,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "status",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "actions",
                "storageKey": "actions(isEditPage:false)",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "isEditPage",
                    "value": false,
                    "type": "Boolean"
                  }
                ],
                "concreteType": "DocumentActionType",
                "plural": true,
                "selections": [
                  v28,
                  v4,
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "actionType",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "actionDate",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "comment",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "canEdit",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isExternal",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "user",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserType",
                    "plural": false,
                    "selections": [
                      v28,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "userDisplay",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "userDisplayType",
                            "value": "FORWARD",
                            "type": "UserDisplayType"
                          }
                        ],
                        "storageKey": "userDisplay(userDisplayType:\"FORWARD\")"
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "epAssociationDocuments",
                "storageKey": null,
                "args": null,
                "concreteType": "EpAssociationDocumentType",
                "plural": true,
                "selections": v29
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "systemDocumentTemplate",
                "storageKey": null,
                "args": null,
                "concreteType": "SystemDocumentTemplateType",
                "plural": false,
                "selections": v29
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "canComment",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "subscribedToComments",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "usersNotificationComment",
                "storageKey": null,
                "args": null,
                "concreteType": "UserCommentNotificationType",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "usersNotificationCommentOn",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserType",
                    "plural": true,
                    "selections": v30
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "usersNotificationCommentOff",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserType",
                    "plural": true,
                    "selections": v30
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "isTemplate",
                "args": null,
                "storageKey": null
              }
            ]
          },
          v2,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "editForm",
            "storageKey": null,
            "args": null,
            "concreteType": "DocumentOverrideFormType",
            "plural": false,
            "selections": [
              v3,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "author",
                "storageKey": null,
                "args": null,
                "concreteType": "UserType",
                "plural": false,
                "selections": [
                  v4,
                  v5,
                  v6,
                  v7,
                  v28
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "category",
                "storageKey": null,
                "args": null,
                "concreteType": "CategoryType",
                "plural": false,
                "selections": v31
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "categoryChoices",
                "storageKey": null,
                "args": null,
                "concreteType": "CategoryType",
                "plural": true,
                "selections": v31
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "flowTemplate",
                "storageKey": null,
                "args": null,
                "concreteType": "ApprovalWorkflowType",
                "plural": false,
                "selections": v31
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "flowTemplateChoices",
                "storageKey": null,
                "args": null,
                "concreteType": "ApprovalWorkflowType",
                "plural": true,
                "selections": v31
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "bloc",
                "storageKey": null,
                "args": null,
                "concreteType": "BlocType",
                "plural": false,
                "selections": v31
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "blocChoices",
                "storageKey": null,
                "args": null,
                "concreteType": "BlocType",
                "plural": true,
                "selections": v31
              },
              v9,
              v10,
              v11,
              v12,
              v13,
              v14,
              v15,
              v16,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "onesourceDocuments",
                "storageKey": null,
                "args": null,
                "concreteType": "OneSourceDocumentType",
                "plural": true,
                "selections": [
                  v17,
                  v18,
                  v19,
                  v20,
                  v21,
                  v28
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "tagForm",
            "storageKey": null,
            "args": null,
            "concreteType": "TagFormType",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "tags",
                "storageKey": null,
                "args": null,
                "concreteType": "TagType",
                "plural": true,
                "selections": v31
              }
            ]
          },
          v22,
          v23,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "systemDocumentTemplateForm",
            "storageKey": null,
            "args": null,
            "concreteType": "SystemDocumentTemplateFormType",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "blocs",
                "storageKey": null,
                "args": null,
                "concreteType": "BlocType",
                "plural": true,
                "selections": v31
              }
            ]
          },
          v24,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "tenantsToRedirect",
            "storageKey": null,
            "args": null,
            "concreteType": "TenantType",
            "plural": true,
            "selections": [
              v3,
              v25,
              v28
            ]
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "ckeditor5",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "rtlSupport",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "newCkeditor",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "ckeditor5AiEnabled",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "ckeditor5LicenseKey",
            "args": null,
            "storageKey": null
          },
          v26,
          v27
        ]
      }
    ]
  }
};
})();
node.text = "query OverridePolicyQuery(\n  $documentPk: Int!\n) {\n  documentOverride(pk: $documentPk) {\n    document {\n      ...PolicyEditor_document\n      id\n    }\n    canLocalize\n    editForm {\n      name\n      author {\n        pk\n        firstName\n        lastName\n        title\n        id\n      }\n      category {\n        pk\n        name\n        id\n      }\n      categoryChoices {\n        pk\n        name\n        id\n      }\n      flowTemplate {\n        pk\n        name\n        id\n      }\n      flowTemplateChoices {\n        pk\n        name\n        id\n      }\n      bloc {\n        pk\n        name\n        id\n      }\n      blocChoices {\n        pk\n        name\n        id\n      }\n      html\n      activeLifespan\n      expirationDate\n      isAForm\n      restricted\n      legacyEffectiveDate\n      approvalDate\n      regulations\n      onesourceDocuments {\n        oneSourceDocumentId\n        catalogNumber\n        manufacturerName\n        viewUrl\n        revisionInformation\n        id\n      }\n    }\n    tagForm {\n      tags {\n        pk\n        name\n        id\n      }\n    }\n    scheduledEffectiveDateForm {\n      effectiveDate\n      effectiveDateTimedelta\n      effectiveDateAlgorithm\n      originationDate\n    }\n    preimportRevisionForm {\n      revisionDates\n    }\n    systemDocumentTemplateForm {\n      blocs {\n        pk\n        name\n        id\n      }\n    }\n    error {\n      statusCode\n      message\n    }\n    tenantsToRedirect {\n      name\n      url\n      id\n    }\n    ...PolicyEditor_editorPropertiesOverride\n    redirectUrl\n    policyActions\n  }\n}\n\nfragment PolicyEditor_document on DocumentType {\n  id\n  pk\n  name\n  status\n  actions(isEditPage: false) {\n    id\n    pk\n    actionType\n    actionDate\n    comment\n    canEdit\n    isExternal\n    user {\n      id\n      userDisplay(userDisplayType: FORWARD)\n    }\n  }\n  epAssociationDocuments {\n    pk\n    id\n  }\n  systemDocumentTemplate {\n    pk\n    id\n  }\n  ...commentForm_document\n  isTemplate\n}\n\nfragment PolicyEditor_editorPropertiesOverride on DocumentOverrideType {\n  ckeditor5\n  ...editor_editorPropertiesOverride\n}\n\nfragment editor_editorPropertiesOverride on DocumentOverrideType {\n  rtlSupport\n  newCkeditor\n  ckeditor5\n  ckeditor5AiEnabled\n  ckeditor5LicenseKey\n}\n\nfragment commentForm_document on DocumentType {\n  id\n  pk\n  canComment\n  status\n  subscribedToComments\n  usersNotificationComment {\n    usersNotificationCommentOn {\n      pk\n      firstName\n      lastName\n      id\n    }\n    usersNotificationCommentOff {\n      pk\n      firstName\n      lastName\n      id\n    }\n  }\n}\n";
(node/*: any*/).hash = '4570de170084223725c8f6cbb290acec';
module.exports = node;
